import { ROUTE_PATHS } from "./constants/router.constants";
import AuditLogPage from "./pages/audit-log";
import ChangePasscodePage from "./pages/change-password/change-passcode";
import DashboardPage from "./pages/dashboard"
import SessionTimedOutPage from "./pages/session-timed-out";
import SignInPage from "./pages/sign-in";
import MyAccountPage from "./pages/my-account";
import SystemConfigPage from "./pages/system-config";
import UserManagementPage from "./pages/user";
import UserRolesPage from "./pages/user-role";
import CreateAndEditRolePage from "./pages/user-role/role-form";
import CreateAndEditUserPage from "./pages/user/user-form";
import AccessResourcePage from "./pages/api-management";
import TerminalManagementPage from "./pages/terminals";
import TerminalLinkingPage from "./pages/terminals/components";
import TerminalDetailPage from "./pages/terminals/components";
import TerminalDetail1 from "./components/views/devices/component/deviceDetail";
import LocationDetail from "./components/views/devices/component/locationDetail";

export interface RouterModel {
  href: string;
  component: () => JSX.Element;
  permissions?: string[];
  children?: RouterModel[]
}

export const anonymousRouters: RouterModel[] = [
  {
    href: ROUTE_PATHS.SignIn,
    component: SignInPage,
  },
  {
    href: ROUTE_PATHS.SessionTimedOut,
    component: SessionTimedOutPage,
  },
  {
    href: ROUTE_PATHS.ChangePasscode,
    component: ChangePasscodePage,
  },
];

export const authorizedRouters: RouterModel[] = [
  {
    href: ROUTE_PATHS.Home,
    component: DashboardPage,
  },
  {
    href: ROUTE_PATHS.MyAccount,
    component: MyAccountPage,
  },
  {
    href: ROUTE_PATHS.Alerts,
    component: DashboardPage,
  },
  {
    href: ROUTE_PATHS.Users,
    component: UserManagementPage,
  },
  {
    href: ROUTE_PATHS.UserCreate,
    component: CreateAndEditUserPage,
  },
  {
    href: ROUTE_PATHS.UserEdit,
    component: CreateAndEditUserPage,
  },
  {
    href: ROUTE_PATHS.Reports,
    component: DashboardPage,
  },
  {
    href: ROUTE_PATHS.SystemConfig,
    component: SystemConfigPage,
  },
  {
    href: ROUTE_PATHS.UserRoles,
    component: UserRolesPage,
  },
  {
    href: ROUTE_PATHS.UserRolesCreate,
    component: CreateAndEditRolePage,
  },
  {
    href: ROUTE_PATHS.UserRolesEdit,
    component: CreateAndEditRolePage,
  },
  {
    href: ROUTE_PATHS.Audits,
    component: AuditLogPage,
  },
  {
    href: ROUTE_PATHS.ApiManagement,
    component: AccessResourcePage
  },
  {
    href: ROUTE_PATHS.TerminalManagement,
    component: TerminalManagementPage,
    children: [
      { href: ROUTE_PATHS.TerminalDetail, component: TerminalDetail1 },
      { href: ROUTE_PATHS.LocationDetail, component: LocationDetail }
      
    ]
  },
  // {
  //   href: ROUTE_PATHS.TerminalDetail,
  //   component: TerminalDetailPage,
  //   children: [
  //     { href: 'component-b', component: TerminalDetail1 } 
  //   ]
  // },
];

export const appRoutes = [...anonymousRouters, ...authorizedRouters];
